import { Component } from '@angular/core';
import { IonNav, ModalController } from '@ionic/angular';
import { PlatformService } from '@panamax/app-state';
import { ServiceRequestService } from '@service-request/services//service-request.service';
import { IssueAndIssueDetailsBaseComponent } from '../issue-and-issue-details-base.component';

@Component({
  selector: 'app-issue-and-issue-details-desktop',
  templateUrl: './issue-and-issue-details-desktop.component.html',
  styleUrls: ['../../request-credit-common-styles.scss'],
})
export class IssueAndIssueDetailsDesktopComponent extends IssueAndIssueDetailsBaseComponent {
  constructor(
    nav: IonNav,
    modalController: ModalController,
    platformService: PlatformService,
    serviceRequestService: ServiceRequestService,
  ) {
    super(nav, modalController, platformService, serviceRequestService);
    this.serviceRequestService.getIssues();
  }
}
